import React, { useState, useRef, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import { apiUrl } from "../../../services/constants";
import { GET_RESOURCE } from "../../../services/graphql-query";
import { FaFilePdf, FaFolderOpen, FaFileArchive } from "react-icons/fa";
import { BsDownload, BsEyeFill } from "react-icons/bs";
import EmailButton from "../../assets/icons/Emailbutton.svg";
import { Modal, Button } from "react-bootstrap";
import { saveAs } from "file-saver";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import validator from "validator";
import { Backdrop, CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

const Resources = () => {
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const [email, setEmail] = useState("");
    const [token, setToken] = useState(null);
    const [pdfDocUrl, setPdfDocUrl] = useState("");
    const [title, setTitle] = useState("");
    const [isCaptchaExpired, setIsCaptchaExpired] = useState(false);
    const [isEmailError, setIsEmailError] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const captchaRef = useRef(null);

    const [isShow, setShow] = useState(false);
    const productName = window.localStorage.getItem("product_name");
    const { data } = useQuery(GET_RESOURCE, {
        pollInterval: 300000,
        variables: { name: productName }
    });
    let download_data = {};
    let spec_data = {};

    useEffect(() => {
        if (isCaptchaExpired) setToken(null);
    }, [isCaptchaExpired]);

    if (data) {
        data.resourcesAndDownloads.data.map(item => {
            download_data = item?.attributes;
        });
        data.collections.data.map(item => {
            spec_data = item?.attributes;
        });
    }

    const handleDownload = (url, name) => {
        const pdf_url = apiUrl + url;
        saveAs(pdf_url, name);
    };

    const handleEmailButton = (url, title) => {
        setPdfDocUrl(apiUrl + url);
        setTitle(title);
        setShow(true);
    };

    const handleVerificationSuccess = token => {
        setToken(token);
        if (token) setIsCaptchaExpired(false);
    };

    const handleEmailSend = () => {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                email: email,
                productName: productName,
                pdfDocUrl: pdfDocUrl,
                title: title
            })
        };

        setIsClicked(true);
        if (!validator.isEmail(email)) {
            setIsEmailError(true);
        } else {
            setIsEmailError(false);
        }

        if (validator.isEmail(email) && token) {
            setIsOpenBackdrop(true);
            fetch(`/api/products/send`, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setIsClicked(false);
                    setEmail("");
                    setToken(null);
                    setPdfDocUrl("");
                    setIsOpenBackdrop(false);
                    captchaRef.current.resetCaptcha();

                    if (result.status === "success") {
                        Swal.fire("Success!", result.msg, "success");
                    } else {
                        Swal.fire("Oops...", result.msg, "error");
                    }
                });
        }
    };

    const pdf_view = url => {
        window.open(apiUrl + url, "_blank");
    };

    return (
        <>
            <div className="mobile-hide">
                <table className="resource-table mt-5">
                    <thead className="table-header">
                        <tr>
                            <th>Document</th>
                            <th>Date Modified</th>
                            <th>File Size</th>
                            <th>Downloadable File</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(spec_data).length !== 0 &&
                            spec_data.spec_pdf.data !== null && (
                                <tr>
                                    <td className="p-4 file-download">
                                        <FaFilePdf
                                            className="mr-4 pdf-icon"
                                            onClick={() =>
                                                pdf_view(
                                                    spec_data.spec_pdf.data
                                                        ?.attributes.url
                                                )
                                            }
                                        />
                                        Spec Sheet
                                    </td>
                                    <td>
                                        {spec_data.spec_pdf.data?.attributes.updatedAt.slice(
                                            0,
                                            10
                                        )}
                                    </td>
                                    <td>
                                        {
                                            spec_data.spec_pdf.data?.attributes
                                                .size
                                        }
                                        KB
                                    </td>
                                    <td className="resource-button-groups">
                                        <button
                                            className="d-flex download-button mr-4"
                                            onClick={() =>
                                                handleDownload(
                                                    spec_data.spec_pdf.data
                                                        ?.attributes.url,
                                                    spec_data.spec_pdf.data
                                                        ?.attributes.name
                                                )
                                            }
                                        >
                                            <BsDownload className="mr-2" />
                                            Download
                                        </button>
                                        <img
                                            className="share-email-button"
                                            src={EmailButton}
                                            onClick={() =>
                                                handleEmailButton(
                                                    spec_data.spec_pdf.data
                                                        ?.attributes.url,
                                                    "pecification"
                                                )
                                            }
                                        />
                                        <BsEyeFill
                                            onClick={() =>
                                                pdf_view(
                                                    spec_data.spec_pdf.data
                                                        ?.attributes.url
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            )}
                        {download_data?.PhotometryIES_zip?.data.length
                            ? download_data?.PhotometryIES_zip?.data.map(
                                (item, key) => (
                                    <tr>
                                        <td className="p-4 file-download">
                                            <FaFileArchive className="mr-4 zip-icon" />
                                            Photometry (IES){" "}
                                            {
                                                item.attributes.name.split(
                                                    "."
                                                )[0]
                                            }
                                        </td>
                                        <td>
                                            {item.attributes.updatedAt.slice(
                                                0,
                                                10
                                            )}
                                        </td>
                                        <td>{item.attributes.size}KB</td>
                                        <td className="resource-button-groups">
                                            <button
                                                className="d-flex download-button mr-4"
                                                onClick={() =>
                                                    handleDownload(
                                                        item.attributes.url,
                                                        item.attributes.name
                                                    )
                                                }
                                            >
                                                <BsDownload className="mr-2" />
                                                Download
                                            </button>
                                            <img
                                                className="share-email-button"
                                                src={EmailButton}
                                                onClick={() =>
                                                    handleEmailButton(
                                                        item.attributes.url,
                                                        "photometry (IES)"
                                                    )
                                                }
                                            />
                                        </td>
                                    </tr>
                                )
                            )
                            : Object.keys(download_data).length !== 0 &&
                            download_data.PhotometryIES_zip.data !== null && (
                                <tr>
                                    <td className="p-4 file-download">
                                        <FaFileArchive className="mr-4 zip-icon" />
                                        Photometry (IES)
                                    </td>
                                    <td>
                                        {download_data.PhotometryIES_zip.data[0]?.attributes.updatedAt.slice(
                                            0,
                                            10
                                        )}
                                    </td>
                                    <td>
                                        {
                                            download_data.PhotometryIES_zip
                                                .data[0]?.attributes.size
                                        }
                                        KB
                                    </td>
                                    <td className="resource-button-groups">
                                        <button
                                            className="d-flex download-button mr-4"
                                            onClick={() =>
                                                handleDownload(
                                                    download_data
                                                        .PhotometryIES_zip
                                                        ?.data[0]?.attributes
                                                        .url,
                                                    download_data
                                                        .PhotometryIES_zip
                                                        ?.data[0]?.attributes
                                                        .name
                                                )
                                            }
                                        >
                                            <BsDownload className="mr-2" />
                                            Download
                                        </button>
                                        <img
                                            className="share-email-button"
                                            src={EmailButton}
                                            onClick={() =>
                                                handleEmailButton(
                                                    download_data
                                                        .PhotometryIES_zip
                                                        ?.data[0]?.attributes
                                                        .url,
                                                    "photometry (IES)"
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            )}
                        {Object.keys(download_data).length !== 0 &&
                            download_data.InstalationSheet_pdf.data !==
                            null && (
                                <tr>
                                    <td className="p-4 file-download">
                                        <FaFilePdf
                                            className="mr-4 pdf-icon"
                                            onClick={() =>
                                                pdf_view(
                                                    download_data
                                                        .InstalationSheet_pdf
                                                        ?.data?.attributes.url
                                                )
                                            }
                                        />
                                        Installation Sheet
                                    </td>
                                    <td>
                                        {download_data.InstalationSheet_pdf.data?.attributes.updatedAt.slice(
                                            0,
                                            10
                                        )}
                                    </td>
                                    <td>
                                        {
                                            download_data.InstalationSheet_pdf
                                                .data?.attributes.size
                                        }
                                        KB
                                    </td>
                                    <td className="resource-button-groups">
                                        <button
                                            className="d-flex download-button mr-4"
                                            onClick={() =>
                                                handleDownload(
                                                    download_data
                                                        .InstalationSheet_pdf
                                                        ?.data?.attributes.url,
                                                    download_data
                                                        .InstalationSheet_pdf
                                                        ?.data?.attributes.name
                                                )
                                            }
                                        >
                                            <BsDownload className="mr-2" />
                                            Download
                                        </button>
                                        <img
                                            className="share-email-button"
                                            src={EmailButton}
                                            onClick={() =>
                                                handleEmailButton(
                                                    download_data
                                                        .InstalationSheet_pdf
                                                        ?.data?.attributes.url,
                                                    "installation sheet"
                                                )
                                            }
                                        />
                                        <BsEyeFill
                                            onClick={() =>
                                                pdf_view(
                                                    download_data
                                                        .InstalationSheet_pdf
                                                        ?.data?.attributes.url
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            )}
                        {Object.keys(download_data).length !== 0 &&
                            download_data.Brochure_pdf.data !== null && (
                                <tr>
                                    <td className="p-4 file-download">
                                        <FaFilePdf
                                            className="mr-4 pdf-icon"
                                            onClick={() =>
                                                pdf_view(
                                                    download_data.Brochure_pdf
                                                        .data?.attributes.url
                                                )
                                            }
                                        />
                                        Brochure
                                    </td>
                                    <td>
                                        {download_data.Brochure_pdf.data?.attributes.updatedAt.slice(
                                            0,
                                            10
                                        )}
                                    </td>
                                    <td>
                                        {
                                            download_data.Brochure_pdf.data
                                                ?.attributes.size
                                        }
                                        KB
                                    </td>
                                    <td className="resource-button-groups">
                                        <button
                                            className="d-flex download-button mr-4"
                                            onClick={() =>
                                                handleDownload(
                                                    download_data.Brochure_pdf
                                                        .data?.attributes.url,
                                                    download_data.Brochure_pdf
                                                        .data?.attributes.name
                                                )
                                            }
                                        >
                                            <BsDownload className="mr-2" />
                                            Download
                                        </button>
                                        <img
                                            className="share-email-button"
                                            src={EmailButton}
                                            onClick={() =>
                                                handleEmailButton(
                                                    download_data.Brochure_pdf
                                                        .data?.attributes.url,
                                                    "brochure"
                                                )
                                            }
                                        />
                                        <BsEyeFill
                                            onClick={() =>
                                                pdf_view(
                                                    download_data.Brochure_pdf
                                                        .data?.attributes.url
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            )}
                        {Object.keys(download_data).length !== 0 &&
                            download_data.Warranty_pdf.data !== null && (
                                <tr>
                                    <td className="p-4 file-download">
                                        <FaFilePdf
                                            className="mr-4 pdf-icon"
                                            onClick={() =>
                                                pdf_view(
                                                    download_data.Warranty_pdf
                                                        .data?.attributes.url
                                                )
                                            }
                                        />
                                        Warranty
                                    </td>
                                    <td>
                                        {download_data.Warranty_pdf.data?.attributes.updatedAt.slice(
                                            0,
                                            10
                                        )}
                                    </td>
                                    <td>
                                        {
                                            download_data.Warranty_pdf.data
                                                ?.attributes.size
                                        }
                                        KB
                                    </td>
                                    <td className="resource-button-groups">
                                        <button
                                            className="d-flex download-button mr-4"
                                            onClick={() =>
                                                handleDownload(
                                                    download_data.Warranty_pdf
                                                        .data?.attributes.url,
                                                    download_data.Warranty_pdf
                                                        .data?.attributes.name
                                                )
                                            }
                                        >
                                            <BsDownload className="mr-2" />
                                            Download
                                        </button>
                                        <img
                                            className="share-email-button"
                                            src={EmailButton}
                                            onClick={() =>
                                                handleEmailButton(
                                                    download_data.Warranty_pdf
                                                        .data?.attributes.url,
                                                    "warranty"
                                                )
                                            }
                                        />
                                        <BsEyeFill
                                            onClick={() =>
                                                pdf_view(
                                                    download_data.Warranty_pdf
                                                        .data?.attributes.url
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            )}
                        {Object.keys(download_data).length !== 0 &&
                            download_data.AllDocuments_zip.data !== null && (
                                <tr>
                                    <td className="p-4 file-download">
                                        <FaFolderOpen className="mr-4 folder-icon" />
                                        All Documents
                                    </td>
                                    <td>
                                        {download_data.AllDocuments_zip.data?.attributes.updatedAt.slice(
                                            0,
                                            10
                                        )}
                                    </td>
                                    <td>
                                        {
                                            download_data.AllDocuments_zip.data
                                                ?.attributes.size
                                        }
                                        KB
                                    </td>
                                    <td className="resource-button-groups">
                                        <button
                                            className="d-flex download-button mr-4"
                                            onClick={() =>
                                                handleDownload(
                                                    download_data
                                                        .AllDocuments_zip.data
                                                        ?.attributes.url,
                                                    download_data
                                                        .AllDocuments_zip.data
                                                        ?.attributes.name
                                                )
                                            }
                                        >
                                            <BsDownload className="mr-2" />
                                            Download
                                        </button>
                                        <img
                                            className="share-email-button"
                                            src={EmailButton}
                                            onClick={() =>
                                                handleEmailButton(
                                                    download_data
                                                        .AllDocuments_zip.data
                                                        ?.attributes.url,
                                                    "All Documents"
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
                <Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={isShow}
                    onHide={() => setShow(false)}
                >
                    <Modal.Header closeButton>
                        <h5 className="modal-title" id="exampleModalLabel">
                            {productName} Specification
                        </h5>
                    </Modal.Header>
                    <Modal.Body>
                        <input
                            name="email"
                            type="email"
                            className={`form-control ${isEmailError
                                ? "is-invalid"
                                : isClicked && "is-valid"
                                }`}
                            id="floatingInput"
                            placeholder="name@gmail.com"
                            defaultValue={email}
                            onChange={e => {
                                setEmail(e.target.value);
                            }}
                        />
                        <label htmlFor="floatingInput">Email address</label>
                        {isEmailError ? (
                            <div className="invalid-feedback">
                                Please enter a valid email.
                            </div>
                        ) : (
                            isClicked && (
                                <div className="valid-feedback">
                                    Looks good!
                                </div>
                            )
                        )}
                        <div className="mt-2">
                            <HCaptcha
                                ref={captchaRef}
                                sitekey="8d147cae-36a3-40e9-a9c5-6f5742ce5219"
                                onVerify={token =>
                                    handleVerificationSuccess(token)
                                }
                                onExpire={() => setIsCaptchaExpired(true)}
                            />
                        </div>
                        {!token && isClicked ? (
                            <p className="text-danger">
                                This is hCaptcha for human testing.
                            </p>
                        ) : (
                            isCaptchaExpired && (
                                <p className="text-danger">
                                    The hCaptcha for human testing has expired.
                                </p>
                            )
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            onClick={() => setShow(false)}
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                            id="closeModal"
                        >
                            Close
                        </Button>
                        <Button
                            onClick={() => handleEmailSend()}
                            type="submit"
                            className="btn btn-dark"
                        >
                            Send
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: theme => theme.zIndex.drawer + 1
                    }}
                    open={isOpenBackdrop}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
            <div className="mobile-show pl-3 pr-3">
                {Object.keys(spec_data).length !== 0 &&
                    spec_data.spec_pdf.data !== null && (
                        <div className="mobile-list-resource">
                            <div className="p-2 file-download">
                                <FaFilePdf
                                    className="mr-4 pdf-icon"
                                    onClick={() =>
                                        pdf_view(
                                            spec_data.spec_pdf.data?.attributes
                                                .url
                                        )
                                    }
                                />
                                Spec Sheet
                            </div>
                            <div className="resource-button-groups">
                                <BsEyeFill
                                    className="mr-3"
                                    onClick={() =>
                                        pdf_view(
                                            spec_data.spec_pdf.data?.attributes
                                                .url
                                        )
                                    }
                                />
                                <BsDownload
                                    onClick={() =>
                                        handleDownload(
                                            spec_data.spec_pdf.data?.attributes
                                                .url,
                                            spec_data.spec_pdf.data?.attributes
                                                .name
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
                {download_data?.PhotometryIES_zip?.data.length
                    ? download_data?.PhotometryIES_zip?.data.map(
                        (item, key) => (
                            <div className="mobile-list-resource">
                                <div className="p-2 file-download">
                                    <FaFileArchive className="mr-4 zip-icon" />
                                    Photometry (IES){" "}
                                    {item.attributes.name.split(".")[0]}
                                </div>
                                <div className="resource-button-groups">
                                    <BsDownload
                                        onClick={() =>
                                            handleDownload(
                                                item.attributes.url,
                                                item.attributes.name
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        )
                    )
                    : Object.keys(download_data).length !== 0 &&
                    download_data.PhotometryIES_zip.data !== null && (
                        <div className="mobile-list-resource">
                            <div className="p-2 file-download">
                                <FaFileArchive className="mr-4 zip-icon" />
                                Photometry (IES)
                            </div>
                            <div className="resource-button-groups">
                                <BsDownload
                                    onClick={() =>
                                        handleDownload(
                                            download_data.PhotometryIES_zip
                                                ?.data[0]?.attributes.url,
                                            download_data.PhotometryIES_zip
                                                ?.data[0]?.attributes.name
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
                {Object.keys(download_data).length !== 0 &&
                    download_data.InstalationSheet_pdf.data !== null && (
                        <div className="mobile-list-resource">
                            <div className="p-2 file-download">
                                <FaFilePdf
                                    className="mr-4 pdf-icon"
                                    onClick={() =>
                                        pdf_view(
                                            download_data.InstalationSheet_pdf
                                                ?.data?.attributes.url
                                        )
                                    }
                                />
                                Installation Sheet
                            </div>
                            <div className="resource-button-groups">
                                <BsEyeFill
                                    className="mr-3"
                                    onClick={() =>
                                        pdf_view(
                                            download_data.InstalationSheet_pdf
                                                ?.data?.attributes.url
                                        )
                                    }
                                />
                                <BsDownload
                                    onClick={() =>
                                        handleDownload(
                                            download_data.InstalationSheet_pdf
                                                ?.data?.attributes.url,
                                            download_data.InstalationSheet_pdf
                                                ?.data?.attributes.name
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
                {Object.keys(download_data).length !== 0 &&
                    download_data.Brochure_pdf.data !== null && (
                        <div className="mobile-list-resource">
                            <div className="p-2 file-download">
                                <FaFilePdf
                                    className="mr-4 pdf-icon"
                                    onClick={() =>
                                        pdf_view(
                                            download_data.Brochure_pdf.data
                                                ?.attributes.url
                                        )
                                    }
                                />
                                Brochure
                            </div>
                            <div className="resource-button-groups">
                                <BsEyeFill
                                    className="mr-3"
                                    onClick={() =>
                                        pdf_view(
                                            download_data.Brochure_pdf.data
                                                ?.attributes.url
                                        )
                                    }
                                />
                                <BsDownload
                                    onClick={() =>
                                        handleDownload(
                                            download_data.Brochure_pdf.data
                                                ?.attributes.url,
                                            download_data.Brochure_pdf.data
                                                ?.attributes.name
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
                {Object.keys(download_data).length !== 0 &&
                    download_data.Warranty_pdf.data !== null && (
                        <div className="mobile-list-resource">
                            <div className="p-2 file-download">
                                <FaFilePdf
                                    className="mr-4 pdf-icon"
                                    onClick={() =>
                                        pdf_view(
                                            download_data.Warranty_pdf.data
                                                ?.attributes.url
                                        )
                                    }
                                />
                                Warranty
                            </div>
                            <div className="resource-button-groups">
                                <BsEyeFill
                                    className="mr-3"
                                    onClick={() =>
                                        pdf_view(
                                            download_data.Warranty_pdf.data
                                                ?.attributes.url
                                        )
                                    }
                                />
                                <BsDownload
                                    onClick={() =>
                                        handleDownload(
                                            download_data.Warranty_pdf.data
                                                ?.attributes.url,
                                            download_data.Warranty_pdf.data
                                                ?.attributes.name
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
                {Object.keys(download_data).length !== 0 &&
                    download_data.AllDocuments_zip.data !== null && (
                        <div className="mobile-list-resource">
                            <div className="p-2 file-download">
                                <FaFolderOpen className="mr-4 folder-icon" />
                                All Documents
                            </div>
                            <div className="resource-button-groups">
                                <BsDownload
                                    onClick={() =>
                                        handleDownload(
                                            download_data.AllDocuments_zip.data
                                                ?.attributes.url,
                                            download_data.AllDocuments_zip.data
                                                ?.attributes.name
                                        )
                                    }
                                />
                            </div>
                        </div>
                    )}
            </div>
        </>
    );
};

export default Resources;
